import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 pt-28 md:pt-32"> {/* ✅ Added top padding to prevent overlap */}
        <section className="py-12">
          <div className="max-w-5xl mx-auto px-4 prose prose-lg text-gray-700">
            <h1 className="text-4xl font-semibold text-[#2563EB] mb-8 text-center">
              Privacy Policy
            </h1>

            <h2 className="text-2xl font-semibold mb-4">Personal Information</h2>
            <p>
              Some personal information including name, contact numbers, e-mail addresses,
              and other demographic information is collected through enquiry forms.{" "}
              <strong>HPR Infra Group</strong> takes precautions to protect your individual
              or personal information from unauthorized use and makes internal use of your
              contact information only to inform you of projects and services that may
              interest you. When you voluntarily send us electronic mail, we will keep a
              record of this information so that we can respond to you. However, we do not
              disclose your information to other public bodies or individuals except as
              authorized by law.
            </p>

            <p>
              As you travel through the <strong>HPR Infra Projects</strong> website, our
              servers log information about your session. Information logged includes
              items such as your IP address, what browser you are using, the time and date
              you visited, how long your session lasted, and what pages you visited. We
              use this information from our server logs primarily to learn about our
              visitors as a group, to track visitors and readership on our website.
            </p>

            <p>
              <strong>HPR INFRA Group</strong> reserves the right to change this policy in
              any manner at any time without prior notice. If we make material changes to
              our privacy policy, the same will be updated on the website.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">Copyright</h2>
            <p>
              The content on this website is the exclusive property of{" "}
              <strong>The HPR INFRA GROUP</strong>.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
